<script>
export default {
  name: "Pasajero",
  props: {
    habitacionNumero: { type: Number, required: true },
    value: { type: Object, required: true },
  },
  computed: {
    edades() {
      const edades = Array.from({ length: 121 }, (value, index) => index);
      if (this.value.tipoKey === "ADL") {
        return edades.filter((edad) => edad >= 13);
      }
      return edades;
    },
  },
};
</script>

<template>
  <table>
    <tr>
      <th>
        <input
          type="hidden"
          :name="
            'habitaciones[' +
            habitacionNumero +
            '][pasajeros][' +
            value.numero +
            '][numero]'
          "
          :value="value.numero"
        />
        <input
          type="hidden"
          :name="
            'habitaciones[' +
            habitacionNumero +
            '][pasajeros][' +
            value.numero +
            '][tipo]'
          "
          :value="value.tipoKey"
        />
        <label :for="'edad_' + value.numero">
          <small>{{ value.numero }}<span v-html="'&deg;'"/></span></small> Pasajero</label
        >
      </th>

      <td>{{ value.tipo }}</td>

      <td>
        <select
          v-model="value.edad"
          class="form-control input-sm"
          :name="
            'habitaciones[' +
            habitacionNumero +
            '][pasajeros][' +
            value.numero +
            '][edad]'
          "
          :id="'edad_' + value.numero"
        >
          <option :value="null">--</option>
          <option v-for="edad in edades" :key="edad" :value="edad">
            {{ edad }}
          </option>
        </select>
      </td>
    </tr>
  </table>
</template>


<style scoped>
table {
  width: 100%;
  table-layout: fixed;
}
table tr {
  border-top: 1px solid lightgrey;
}
table td {
  padding: 5px;
}
table td:nth-child(2) {
  width: 105px;
}
table td:nth-child(3) {
  width: 70px;
}
</style>